import type * as React from 'react';
const SvgIcoVariablesFolder = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.825 1.325A1.67 1.67 0 0 0 6.642.833H2.333C1.417.833.675 1.583.675 2.5l-.008 10c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V4.167c0-.917-.75-1.667-1.666-1.667H9z"
      fill="currentColor"
      fillOpacity={0.56}
    />
  </svg>
);
export default SvgIcoVariablesFolder;
